module.exports = __webpack_public_path__ + "img/Gallery_2_09.70502e1a.jpeg";